"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VD_CUSTOMER_API_URL = exports.CREATE_CUSTOMER_URL = exports.PAGE_CONTENT_URL = void 0;
/**
 * @constant
 * @type {string}
 * @description URL base para requisições de conteúdo do formulário genérico.
 */
exports.PAGE_CONTENT_URL = process.env.REACT_APP_PAGE_CONTENT_URL;
/**
 * @constant
 * @type {string}
 * @description URL base para requisições de criação de cliente no BFF de Reconhecimento.
 */
exports.CREATE_CUSTOMER_URL = process.env.REACT_APP_CREATE_CUSTOMER_URL;
/**
 * @constant
 * @type {string}
 * @description URL base para requisições de dados do cliente.
 */
exports.VD_CUSTOMER_API_URL = process.env.REACT_APP_VD_CUSTOMER_API_URL;
